module.exports = "https://99designs-start-assets.imgix.net/js/942dea266a32a39916122a01ab8baa6e.svg";